import React from 'react';
import '../Styles/Testimonials.css';

class Testimonials extends React.Component {
    render() {
      return (
           <div id="testmonial">
  <section className="section" >
  <div className="container">
    <h1 className="section-title text-center mb-0" style={{color:"#004aac"}}>Words From Our Clients!</h1>
    <figure className="snip1533">
  <figcaption>
    <blockquote>
      <p>We had a wonderful stay at Madaba. The environment and the atmosphere helped us to relax. We had a very good stay.</p>
    </blockquote>
    <h3>Wisteria Ravenclaw</h3>
    <h4>Google Inc.</h4>
  </figcaption>
</figure>
<figure className="snip1533">
  <figcaption>
    <blockquote>
      <p>Excellent Reception, clean tidy, sweet memories and Smooth transaction experience. Thank you all.</p>
    </blockquote>
    <h3>Ursula Gurnmeister</h3>
    <h4>Facebook</h4>
  </figcaption>
</figure>
<figure className="snip1533">
  <figcaption>
    <blockquote>
      <p>"Had a very relaxed stay. Great service amazing farm. Lovely building, calming greenery,  We will be back again hopefully. </p>
    </blockquote>
    <h3>Ingredia Nutrisha</h3>
    <h4>Twitter</h4>
  </figcaption>
</figure>
  </div>
</section>
        
           </div>
        )
    }
  }
  
  export default Testimonials;